import { render, staticRenderFns } from "./DetailTransaksiGadai.vue?vue&type=template&id=adf92e6c&scoped=true&"
import script from "./DetailTransaksiGadai.vue?vue&type=script&lang=js&"
export * from "./DetailTransaksiGadai.vue?vue&type=script&lang=js&"
import style0 from "./DetailTransaksiGadai.vue?vue&type=style&index=0&id=adf92e6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf92e6c",
  null
  
)

export default component.exports